type FONT = {
    bold?: string;
    medium?: string;
    regular?: string;
    semibold?: string;
}

const superHero: FONT = {
    bold: "CantedFX-Bold",
    regular: "CantedFX-Regular"
}

const primary: FONT = {
    bold: "Dosis-Bold",
    medium:  "Dosis-Medium",
    regular: "Dosis-Regular",
    semibold: "Dosis-SemiBold"
}

export default {
    primary,
    superHero
}